import { useEffect } from "react";
import { useParams } from "react-router-dom";

import ProductImageGallery from "../components/Clothing/ProductImageGallery";
import ProductInfo from "../components/Clothing/ProductInfo";
import CustomerReviews from "../components/Clothing/CustomerReviews";
import ClothingBestDeal from "../components/Clothing/ClothingBestDeal";
import clothingProductData from "../data/clothingProductData";
import bestDeals from "../data/clothingData";

import "../components/Clothing/ClothingProductScreen.css";

const ClothingProductScreen = () => {
  // Future-proof: supports dynamic product ID from URL
  const { id } = useParams();
  console.log("Product Id", id);

  // Using static product for now (you can fetch by ID later)
  const { product, reviews } = clothingProductData;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!product) return <div>Loading...</div>;

  return (
    <div className="clothing-product-screen">
      {/* BREADCRUMB */}
      <nav className="clothing-breadcrumb" aria-label="breadcrumb">
        {product.breadcrumb.map((crumb, index) => (
          <span key={index}>
            <a href="/" className="breadcrumb-link">
              {crumb}
            </a>
            {index < product.breadcrumb.length - 1 && (
              <span className="separator">/</span>
            )}
          </span>
        ))}
      </nav>

      <div className="clothing-product-main">
        {/* LEFT COLUMN */}
        <div className="clothing-product-left">
          <ProductImageGallery product={product} />
          <CustomerReviews reviews={reviews} />
        </div>

        {/* RIGHT COLUMN */}
        <div className="clothing-product-right">
          <ProductInfo product={product} />
        </div>
      </div>

      {/* BEST DEALS */}
      <section className="clothing-page clothing-category-section">
        <ClothingBestDeal products={bestDeals} />
      </section>
    </div>
  );
};

export default ClothingProductScreen;
